import { render, staticRenderFns } from "./ArticleIndex.vue?vue&type=template&id=6fd0171c&scoped=true&"
import script from "./ArticleIndex.vue?vue&type=script&lang=ts&"
export * from "./ArticleIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleIndex.vue?vue&type=style&index=0&id=6fd0171c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0171c",
  null
  
)

export default component.exports